// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"30bf034d","239":"b1fcd4a5","453":"f9afe20d","667":"09523e0c"}[chunkId] + ".chunk.js";
};